module.exports = __webpack_public_path__ + "static/media/certificate_02.cd70446b.jpg";